<template>
    <div id="auth-layout">
        <div class="justify-content-center d-flex flex-row mb-5">
            <img
                :src="require('../assets/foove-platform-logo.svg')"
                alt="Login logo"
                style="width: 200px; height: auto;"
            >
        </div>
        <div class="form-wrapper">
            <h3>Login</h3>
            <form @submit.prevent="login" action="">
                <div v-if="errors" class="errors">
                    <p v-for="(error, field) in errors" :key="field">
                        {{ error[0] }}
                    </p>
                </div>
                <input type="email" v-model="form.login" placeholder="Ihre Emailadresse"
                       required><br>
                <input type="password" v-model="form.password" placeholder="Ihr Passwort"
                       required><br>
                <button>Login</button>
            </form>
        </div>
        <!-- Text at the bottom of the screen -->
        <div class="footer-text">
            <img
                :src="require('../assets/foove-GmbH-legal-logo.png')"
                alt="logo bottom"
                style="width: 200px; height: auto;"
                class="mb-2"
            >
            <h6 class="text-center footer-copyright">2024 <span class="divider">|</span> Brandshofer Deich 68 <span class="divider">|</span> 20539 Hamburg</h6>
        </div>
    </div>
</template>

<script>
import {loginRequest} from "@/api/auth";

export default {
    name: "Login",
    data() {
        return {
            form:   {
                login:    '',
                password: ''
            },
            errors: null
        }
    },
    methods: {
        async login() {
            await loginRequest(this.form)
                .then(this.handleResponse);
        },
        handleResponse(response) {
            window.localStorage.setItem('ACCESS_TOKEN', response.data.auth_key);
            window.localStorage.setItem('USER_NAME', response.data.username);
            this.$store.dispatch('setAuth', response.data);
            this.$store.dispatch('setLocations', response.data.locations);
            this.$store.dispatch('setLimitOrders');
            this.$store.dispatch('setSelectedKioskConsumer', null);
            this.$router.push({name: "menu-items"});
        },
    }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/custom_theme";

.footer-text {
    position: fixed;
    bottom: 20px;
    text-align: center;
    width: 100%;
    font-size: 14px;
    color: #666666;
}

h6.footer-copyright {
    font-family: 'Lufga', sans-serif;
    color: $base-color !important;
}

.divider {
    color: #EC665A !important;
}

#auth-layout {
    padding: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 80vh;
    text-align: center;
}

#auth-layout .form-wrapper {
    background-color: white;
    padding: 20px;
    width: 300px;
    margin: 0 auto;
    border-radius: 4px;
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);
}

#auth-layout .form-wrapper h3 {
    text-align: center;
    margin-bottom: 30px;
}

#auth-layout form input {
    display: block;
    width: 100%;
    border: 2px solid #e6e6e6;
    padding: 6px 12px;
    transition: all 0.3s;
}

#auth-layout form input:focus {
    outline: 0;
    border-color: rgb(52 144 220 / 25%);
}

#auth-layout form button {
    outline: 0;
    cursor: pointer;
    border: 1px solid $base-color;
    background-color: $base-color;
    color: white;
    padding: 6px 12px;
    transition: all 0.3s;
}

#auth-layout form button:hover {
    background-color: $base-color;
}

#auth-layout form .errors {
    margin-bottom: 15px;
    padding: 10px 15px;
    color: #ffffff;
    background-color: #ff6969;
    font-size: 12px;
}

#auth-layout form .errors p {
    margin: 0;
}

#auth-layout form .link {
    font-size: 80%;
    float: right;
}
</style>
